module.exports = __webpack_public_path__ + "img/advantages_new.538cebe3.png";